import * as React from 'react';
import gql from 'graphql-tag';
import { MutationFn, MutationResult } from 'react-apollo';
import AuthorizedMutation from './AuthorizedMutation';

const GQL = gql`
  mutation CreateReport($type: String!, $params: ReportInput!) {
    createReport(type: $type, params: $params) {
      downloadUrl
    }
  }
`;

export interface ReportParams {
  fieldId?: string;
  fieldIds?: string[];
  documentId?: string;
  documentIds?: string[];
  sinceDate?: number;
  untilDate?: number;
  customBins?: NdviRasterBin[];
  zoneAnalysisDocumentId?: string;
}

export interface Result {
  create: () => void;
  loading: boolean;
  report: ReportDocument;
}

interface Props {
  type: string;
  farmId: string | null;
  params: ReportParams | null;
  onCompleted?: (data: ReportDocument) => void;
  children: (result: Result) => React.ReactNode;
}

function buildVariables(props: Props) {
  const { type, params, farmId } = props;
  return {
    variables: {
      type: type,
      params: {
        ...params,
        farmId: farmId,
        customBins:
          params && params.customBins ? params.customBins.map(b => ({...b, __typename: undefined})) : undefined
      }
    }
  };
}

function renderChildren(
  props: Props,
  mutate: MutationFn,
  result: MutationResult
): React.ReactNode {
  const vars = buildVariables(props);
  const createFn = () => mutate(vars);

  return props.children({
    create: createFn,
    loading: result.loading,
    report: result.data && result.data.createReport
  });
}

const CreateReportProvider: React.SFC<Props> = (props: Props) => {
  return (
    <AuthorizedMutation
      mutation={GQL}
      onCompleted={data => props.onCompleted && props.onCompleted(data.createReport)}
      children={(mutate, result) => renderChildren(props, mutate, result)}
    />
  );
};

export default CreateReportProvider;



// WEBPACK FOOTER //
// ./src/providers/CreateReportProvider.tsx